import { memo } from 'react';
import {
    CalendarBlankIcon,
    CheckIcon,
    CircleIcon,
    ClockIcon,
    LockIcon,
} from '@lingoda/ui/icons/lingodaIcons';
import { colorsPalette } from '@lingoda/ui/theme';
import { useTheme } from '@lingoda/ui';
import { LessonStatus } from '@lingoda/learning-units';

interface LessonStatusIconProps {
    lessonStatus: LessonStatus;
    alt?: string;
}

const LessonStatusIcon = ({ lessonStatus, alt }: LessonStatusIconProps) => {
    const theme = useTheme();

    switch (lessonStatus) {
        case LessonStatus.Locked:
            return <LockIcon size={24} color={theme.palette.text.secondary} alt={alt} />;
        case LessonStatus.Completed:
        case LessonStatus.CompletedImproved:
            return <CheckIcon size={24} color={theme.colors.text.success} alt={alt} />;
        case LessonStatus.Skip:
            return <CheckIcon size={24} color={theme.palette.text.secondary} alt={alt} />;
        case LessonStatus.Booked:
            return <CalendarBlankIcon size={24} color={theme.colors.text.success} alt={alt} />;
        case LessonStatus.Pending:
            return <ClockIcon size={24} color={theme.colors.text.success} alt={alt} />;
        default:
            return <CircleIcon size={24} color={colorsPalette.blackSolid[20]} alt={alt} />;
    }
};

export default memo(LessonStatusIcon);
